import React from 'react';
import { connect } from 'react-redux';
import DemoModeHeader from '../../../features/demoMode/reading/DemoModeHeader/DemoModeHeader';
import DemoHeaderBodyContainer from './DemoHeaderBodyContainer';
import DemoModeBarContainer from './DemoModeBarContainer';
import { setDemoType } from '../../../api/demoMode/reading/demoModeActions';
import { selectors } from '../../../root/reading/root';

const mapStateToProps = state => ({
    isDemoModeOn: selectors.getIsDemoModeOn(state),
    demoType: selectors.getDemoType(state),
});

const mapDispatchToProps = dispatch => ({
    setDemoType: newDemoType => {
        dispatch(setDemoType(newDemoType));
    },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        demoModeBar: <DemoModeBarContainer />,
        demoHeaderBody: <DemoHeaderBodyContainer />,
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DemoModeHeader);
